import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';
export const ConversationUnassigned = ({ entry, }) => {
    const agentName = getAuthorName(Object.assign(Object.assign({}, entry), { author: entry.agent }));
    const agentLink = _jsx(UserLink, Object.assign({ userId: entry.agent.id }, { children: agentName }));
    const text = _jsxs(_Fragment, { children: ["Conversation is unassigned from ", agentLink] });
    return _jsx(LogEntry, { entry: entry, text: text });
};
